import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpHeaders
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { LoginService } from '../shared/servicio/login/login.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  token: string;

  constructor(private _login: LoginService) {}

  getToken() {
    return this._login.getToken();
  }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Las rutas publicas de bonusqr (formulario de canje que abre el paciente
    // sin sesion) no deben llevar el token de sesion que haya quedado en el
    // localStorage del dispositivo, o el backend las rechaza con 403.
    const isPublicBonusQr = request.url.indexOf('/bonusqr/public/') !== -1;

    // Verificar si la solicitud ya tiene el encabezado `Token`
    if (!isPublicBonusQr && !request.headers.has('Token')) {
      // Agregar el token de sesión solo si no existe un token personalizado
      this.token = this.getToken();
      if (this.token != null) {
        request = request.clone({
          setHeaders: {
            Token: 'Bearer ' + this.token
          }
        });
      }
    }

    return next.handle(request);
  }
}
